module.exports = __webpack_public_path__ + "static/FloodXpert_V2_update-837a1b1e05741fd74f1bb9ff76c363e8.png";